import Objdict from "objdict"
import Preload from "@frog/source/utility/Preload.js"
import PaletteSwap from "@frog/source/juice/utility/PaletteSwap.js"

const imagePaths = {
    "dungeonwalls": require("@frog/source/assets/images/dungeon-tactics/tiles/dungeoncorners.png"),
    "sand": require("@frog/source/assets/images/dungeon-tactics/tiles/sand.png"),
    "tree": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/tree_1.png"),
    "house": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/house.png"),
    "mountain": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/mountain_1.png"),
    "fort": require("@frog/source/assets/images/hero-tactics/map/grasslands/objects/fort_red.png"),
    "cactus": require("@frog/source/assets/images/hero-tactics/map/desert/objects/cactus_1.png"),
    "rocks": require("@frog/source/assets/images/hero-tactics/map/desert/objects/rocks_1.png"),
    "boulder": require("@frog/source/assets/images/hero-tactics/map/desert/objects/rocks_2.png"),
    "stone": require("@frog/source/assets/images/hero-tactics/map/desert/objects/rocks_3.png"),
    "obelisk": require("@frog/source/assets/images/hero-tactics/map/desert/objects/obelisk.png"),
    "tent": require("@frog/source/assets/images/hero-tactics/map/desert/objects/tent_blue.png"),
    "bones": require("@frog/source/assets/images/hero-tactics/map/desert/objects/bones_1.png"),
}

const R_SHADE = 0.8
const G_SHADE = 0.6
const B_SHADE = 0.6

const tileset = {
    "hero/grass1": {
        "key": "hero/grass1",
        "equivalentGIDs": [13],
        "drawOrder": 1,
        "tint": {
            "R": 218,
            "G": 212,
            "B": 94,
        }, // hex: DAD45E
        "channelKey": "floor",
    },
    "hero/grass2": {
        "key": "hero/grass2",
        "equivalentGIDs": [12],
        "drawOrder": 1,
        "tint": {
            "R": 204,
            "G": 195,
            "B": 94,
        }, // hex: CCC35E
        "channelKey": "floor",
    },
    "hero/sand1": {
        "key": "hero/sand1",
        "equivalentGIDs": [8],
        "drawOrder": 1,
        "tint": {
            "R": 224,
            "G": 164,
            "B": 100,
        }, // hex: E0A464
        "channelKey": "floor",
    },
    "hero/sand2": {
        "key": "hero/sand2",
        "equivalentGIDs": [7],
        "drawOrder": 1,
        "tint": {
            "R": 231,
            "G": 146,
            "B": 75,
        }, // hex: E7924B
        "channelKey": "floor",
    },
    "hero/path": {
        "key": "hero/path",
        "equivalentGIDs": [35, 36, 40, 41, 45, 46],
        "tilespread": {"images": {
            "1": require("@frog/source/assets/images/tool-kit/road/n.png"),
            "2": require("@frog/source/assets/images/tool-kit/road/e.png"),
            "3": require("@frog/source/assets/images/tool-kit/road/ne.png"),
            "4": require("@frog/source/assets/images/tool-kit/road/s.png"),
            "5": require("@frog/source/assets/images/tool-kit/road/ns.png"),
            "6": require("@frog/source/assets/images/tool-kit/road/se.png"),
            "7": require("@frog/source/assets/images/tool-kit/road/nse.png"),
            "8": require("@frog/source/assets/images/tool-kit/road/w.png"),
            "9": require("@frog/source/assets/images/tool-kit/road/nw.png"),
            "10": require("@frog/source/assets/images/tool-kit/road/ew.png"),
            "11": require("@frog/source/assets/images/tool-kit/road/new.png"),
            "12": require("@frog/source/assets/images/tool-kit/road/sw.png"),
            "13": require("@frog/source/assets/images/tool-kit/road/nsw.png"),
            "14": require("@frog/source/assets/images/tool-kit/road/sew.png"),
            "15": require("@frog/source/assets/images/tool-kit/road/nsew.png"),
        }},
        "tilespreadType": "edge-match",
        "drawOrder": 3,
        "channelKey": "paving",
    },
    "hero/river": {
        "key": "hero/river",
        "tilespread": {"images": {
            "0": require("@frog/source/assets/images/tool-kit/river/0.png"),
            "1": require("@frog/source/assets/images/tool-kit/river/n.png"),
            "2": require("@frog/source/assets/images/tool-kit/river/e.png"),
            "3": require("@frog/source/assets/images/tool-kit/river/ne.png"),
            "4": require("@frog/source/assets/images/tool-kit/river/s.png"),
            "5": require("@frog/source/assets/images/tool-kit/river/ns.png"),
            "6": require("@frog/source/assets/images/tool-kit/river/se.png"),
            "7": require("@frog/source/assets/images/tool-kit/river/nse.png"),
            "8": require("@frog/source/assets/images/tool-kit/river/w.png"),
            "9": require("@frog/source/assets/images/tool-kit/river/nw.png"),
            "10": require("@frog/source/assets/images/tool-kit/river/ew.png"),
            "11": require("@frog/source/assets/images/tool-kit/river/new.png"),
            "12": require("@frog/source/assets/images/tool-kit/river/sw.png"),
            "13": require("@frog/source/assets/images/tool-kit/river/nsw.png"),
            "14": require("@frog/source/assets/images/tool-kit/river/sew.png"),
            "15": require("@frog/source/assets/images/tool-kit/river/nsew.png"),
        }},
        "tilespreadType": "edge-match",
        "drawOrder": 2,
        "channelKey": "water",
    },
    "hero/water": {
        "key": "hero/water",
        "equivalentGIDs": [75, 76, 78, 79, 80, 83, 84, 85, 86, 87], // rounds-up the lake size to the nearest corner
        //"equivalentGIDs": [83], // rounds-down the lake size to the nearest corner
        "tilespread": {"images": {
            "1": require("@frog/source/assets/images/tool-kit/lake/nw.png"),
            "2": require("@frog/source/assets/images/tool-kit/lake/ne.png"),
            "3": require("@frog/source/assets/images/tool-kit/lake/nwne.png"),
            "4": require("@frog/source/assets/images/tool-kit/lake/se.png"),
            "5": require("@frog/source/assets/images/tool-kit/lake/nwse.png"),
            "6": require("@frog/source/assets/images/tool-kit/lake/nese.png"),
            "7": require("@frog/source/assets/images/tool-kit/lake/nwnese.png"),
            "8": require("@frog/source/assets/images/tool-kit/lake/sw.png"),
            "9": require("@frog/source/assets/images/tool-kit/lake/nwsw.png"),
            "10": require("@frog/source/assets/images/tool-kit/lake/nesw.png"),
            "11": require("@frog/source/assets/images/tool-kit/lake/nwnesw.png"),
            "12": require("@frog/source/assets/images/tool-kit/lake/sesw.png"),
            "13": require("@frog/source/assets/images/tool-kit/lake/nwsesw.png"),
            "14": require("@frog/source/assets/images/tool-kit/lake/nesesw.png"),
            "15": require("@frog/source/assets/images/tool-kit/lake/nwnesesw.png"),
        }},
        "tilespreadType": "corner-match",
        "grid": "corner",
        "drawOrder": 2,
        "channelKey": "water",
    },
    "hero/tree": {
        "key": "hero/tree",
        "equivalentGIDs": [64, 65],
        "drawOrder": 100,
        "tilespread": imagePaths["tree"],
        "tilespreadType": "standalone",
        "grid": "face",
        "tileSize": 16,
    },
    "hero/house": {
        "key": "hero/house",
        "drawOrder": 100,
        "tilespread": imagePaths["house"],
        "tilespreadType": "standalone",
        "grid": "face",
        "tileSize": 16,
    },
    "hero/mountain": {
        "key": "hero/mountain",
        "drawOrder": 100,
        "tilespread": imagePaths["mountain"],
        "tilespreadType": "standalone",
        "grid": "face",
        "tileSize": 16,
    },
    "hero/fort": {
        "key": "hero/fort",
        "equivalentGIDs": [59],
        "drawOrder": 100,
        "tilespread": imagePaths["fort"],
        "tilespreadType": "standalone",
        "grid": "face",
        "tileSize": 16,
    },
    "hero/rocks": {
        "key": "hero/rocks",
        "equivalentGIDs": [70],
        "drawOrder": 100,
        "tilespread": imagePaths["rocks"],
        "tilespreadType": "standalone",
        "grid": "face",
        "tileSize": 16,
    },
    "hero/cactus": {
        "key": "hero/cactus",
        "equivalentGIDs": [68, 69],
        "drawOrder": 100,
        "tilespread": imagePaths["cactus"],
        "tilespreadType": "standalone",
        "grid": "face",
        "tileSize": 16,
    },
    "hero/obelisk": {
        "key": "hero/obelisk",
        "drawOrder": 100,
        "tilespread": imagePaths["obelisk"],
        "tilespreadType": "standalone",
        "grid": "face",
        "tileSize": 16,
    },
    "hero/tent": {
        "key": "hero/tent",
        "equivalentGIDs": [74],
        "drawOrder": 100,
        "tilespread": imagePaths["tent"],
        "tilespreadType": "standalone",
        "grid": "face",
        "tileSize": 16,
    },
    "hero/bones": {
        "key": "hero/bones",
        "equivalentGIDs": [66],
        "drawOrder": 100,
        "tilespread": imagePaths["bones"],
        "tilespreadType": "standalone",
        "grid": "face",
        "tileSize": 16,
        "channelKey": "decor",
    },
    "18": {
        "key": "18",
        "name": "void",
        "tileType": 18,
        "tilespread": imagePaths["dungeonwalls"],
        "tilespreadType": "corner-match",
        "grid": "corner",
        "tileSize": 96,
        "drawOrder": 100,
        "tint": {
            "R": 100 * R_SHADE,
            "G": 70 * G_SHADE,
            "B": 50 * B_SHADE,
        }
    },
    "17": {
        "key": "17",
        "name": "wood columns",
        "tileType": 17,
        "drawOrder": 5,
        "tint": {
            "R": 100 * R_SHADE,
            "G": 70 * G_SHADE,
            "B": 50 * B_SHADE,
        }
    },
    "planks": {
        "key": "planks",
        "equivalentGIDs": [1, 16],
        "tileType": 16,
        "drawOrder": 10,
        "tint": {
            "R": 200 * R_SHADE,
            "G": 150 * G_SHADE,
            "B": 100 * B_SHADE,
        },
        "isGridded": true,
        "channelKey": "floor",
    },
    "15": {
        "key": "15",
        "name": "shaded sea",
        "tileType": 15,
        "drawOrder": 1,
        "tint": {
            "R": 20 * R_SHADE,
            "G": 0 * G_SHADE,
            "B": 40 * B_SHADE,
        },
        "channelKey": "floor",
    },
    "14": {
        "key": "14",
        "name": "sea",
        "tileType": 14,
        "drawOrder": 1,
        "tint": {
            "R": 50 * R_SHADE,
            "G": 0 * G_SHADE,
            "B": 100 * B_SHADE,
        },
        "channelKey": "floor",
    },
    "sand": {
        "key": "sand",
        "name": "sand",
        "drawOrder": 1,
        "tilespread": imagePaths["sand"],
        "tilespreadType": "corner-match",
        "grid": "corner",
        "tileSize": 128,
        "tint": {
            "R": 255 * R_SHADE,
            "G": 255 * G_SHADE,
            "B": 255 * B_SHADE,
        },
        "channelKey": "floor",
    },
    "redwall": {
        "key": "redwall",
        "tilespread": imagePaths["dungeonwalls"],
        "tilespreadType": "corner-match",
        "grid": "corner",
        "gradientSwap": [
            {
                "r": 1,
                "g": 1,
                "b": 30
            },
            {
                "r": 248,
                "g": 120,
                "b": 128,
            },
        ],
        "tileSize": 96,
        "drawOrder": 20,
    },
    "3": {
        "key": "3",
        "name": "wall",
        "tileType": 3,
        "tilespread": imagePaths["dungeonwalls"],
        "tilespreadType": "corner-match",
        "grid": "corner",
        "tileSize": 96,
        "drawOrder": 20,
        "tint": {
            "R": 200 * R_SHADE,
            "G": 150 * G_SHADE,
            "B": 100 * B_SHADE,
        }
    },
}

const images = {}
Object.keys(tileset).forEach((key) => {
    const tilesetting = tileset[key]
    if(tilesetting.tilespread == undefined) return
    if(tilesetting.tilespread.images != undefined) {
        Object.keys(tilesetting.tilespread.images).forEach((imageKey) => {
            images[key + imageKey] = {
                "key": key + imageKey,
                "url": tilesetting.tilespread.images[imageKey],
                "callback": (image) => {
                    if(tilesetting.gradientSwap != undefined) {
                        tilesetting.images[imageKey] = new Image()
                        tilesetting.images[imageKey].src = PaletteSwap({
                            "imageElement": image.element,
                            "colors": tilesetting.gradientSwap
                        })
                    } else {
                        if(tilesetting.images == undefined) tilesetting.images = {}
                        tilesetting.images[imageKey] = image.element
                    }
                },
            }
        })
        return
    }
    images[key] = {
        "key": key,
        "url": tilesetting.tilespread,
        "callback": (image) => {
            if(tilesetting.gradientSwap != undefined) {
                tilesetting.image = new Image()
                tilesetting.image.src = PaletteSwap({
                    "imageElement": image.element,
                    "colors": tilesetting.gradientSwap
                })
            } else {
                tilesetting.image = image.element
            }
        },
    }
})
const preload = new Preload({
    "images": images
})

export {preload, tileset}
